import type { ComponentSingleStyleConfig } from '@chakra-ui/theme';

export const ImageComponent: ComponentSingleStyleConfig = {
  baseStyle: {
    objectFit: 'contain',
    objectPosition: 'center center',
  },
};
